import { Component, Inject } from '@angular/core';
import {
  MatDialogRef,
  MAT_DIALOG_DATA,
  MatDialogModule,
} from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { FormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';

/**
 * Small modal asking the user for a name before saving the current PICOST
 * generation to the grade_revisions table. Returns the trimmed name via
 * dialogRef.close(name), or undefined if cancelled.
 */
@Component({
  selector: 'app-picost-name-dialog',
  standalone: true,
  imports: [
    MatDialogModule,
    MatButtonModule,
    MatIconModule,
    MatFormFieldModule,
    MatInputModule,
    FormsModule,
    TranslateModule,
  ],
  templateUrl: './picost-name-dialog.component.html',
})
export class PicostNameDialogComponent {
  name: string;

  constructor(
    public dialogRef: MatDialogRef<PicostNameDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { suggestedName?: string },
  ) {
    this.name = data?.suggestedName || '';
  }

  confirm(): void {
    const trimmed = (this.name || '').trim();
    if (trimmed) {
      this.dialogRef.close(trimmed);
    }
  }

  cancel(): void {
    this.dialogRef.close();
  }
}
